import { createFileRoute } from "@tanstack/react-router"
import { RequestVerifyEmail } from "@/app"

export const Route = createFileRoute("/(public)/auth/verify/request")({
  component: RouteComponent,
})

function RouteComponent() {
  return <RequestVerifyEmail />
}
